module.exports = __webpack_public_path__ + "img/factory-white.b5c2e959.png";